import React from 'react';

import { removeDecimalsToStringPerAcre } from '../../../helpers/NumberFormatting';

const getPerAcre = (val: number | undefined, acres: number) => {
  return val ? ` (${removeDecimalsToStringPerAcre(val, acres, 2)})` : null;
};

interface Props {
  val: number | undefined;
  acres: number;
  val2?: number;
}

const PerAcre: React.FC<Props> = ({ val, acres, val2 }) => {
  return (
    <>
      <span>{val}</span>
      {val2 && <span> ({val2}%)</span>}
      <span style={{ color: 'orange' }}>{getPerAcre(val, acres)}</span>
    </>
  );
};
export default PerAcre;
